import { Outlet } from 'react-router';
import { BackgroundGradient, Navbar } from '@/app/components/layout';
import { useAuthStore } from '@/stores/authStore';

export function RootLayout() {
  const { user } = useAuthStore();
  const messageBalance = user?.remainingMessages ?? 0;

  return (
    <div className="min-h-screen bg-black font-['Inter',sans-serif]">
      <BackgroundGradient />
      <Navbar messageBalance={messageBalance} />
      <main className="relative z-0">
        <Outlet />
      </main>
    </div>
  );
}
